/* unplugin-vue-components disabled */import { render } from "./VoiceSelectorModal.vue?vue&type=template&id=1374a391&scoped=true&ts=true"
import script from "./VoiceSelectorModal.vue?vue&type=script&lang=ts"
export * from "./VoiceSelectorModal.vue?vue&type=script&lang=ts"

import "./VoiceSelectorModal.vue?vue&type=style&index=0&id=1374a391&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1374a391"]])

export default __exports__